import React, {useRef, useEffect, useMemo} from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { Formik, Form, Field } from 'formik';
import { InputFloatingLabel, RadioButtonGroup, RadioButton } from "../../formik";

const SimulatorPopup = ({ intl, setShowSimulator }) => {

  const node = useRef();

  const handleClick = useMemo((e) => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click 
    setShowSimulator(false)
  }, [setShowSimulator]);

  useEffect(() => {
    // add when mounted
    document.addEventListener("mousedown", handleClick);
    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [handleClick]);

  return (
    <div className="add-credits-popup-container">
      <div className="add-credits-popup simulator-popup" ref={node}>
        <div className="p-header">
          <h5>
            {intl.formatMessage({ id: 'heading.simulator' })}
            <Button onClick={() => setShowSimulator(false)}><img src="/icons/close.png" alt="close" /></Button>
          </h5>
        </div>
        <div className="form-p">
          <Formik
            initialValues={{
              numberofrooms: '',
              numberofdays: '',
              additionalboradcastyears: '',
              forquiz: ''
            }}
            onSubmit={values => console.log(values)}
          >
            {({ values, handleSubmit }) => {
              return (
                <Form>
                  <Row className="align-items-center">
                    <Col xs={6}>
                      <Field
                        component={InputFloatingLabel}
                        type="number"
                        placeholder={intl.formatMessage({
                          id: "no.rooms",
                        })}
                        label={intl.formatMessage({
                          id: "no.rooms",
                        })}
                        name="numberofrooms"
                        id="numberofrooms"
                      />
                    </Col>
                    <Col xs={6}>
                      <Field
                        component={InputFloatingLabel}
                        type="number"
                        placeholder={intl.formatMessage({
                          id: "no.days",
                        })}
                        label={intl.formatMessage({
                          id: "no.days",
                        })}
                        name="numberofdays"
                        id="numberofdays"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Field
                        component={InputFloatingLabel}
                        type="number"
                        placeholder={intl.formatMessage({
                          id: "additional.boradcast.years",
                        })}
                        label={intl.formatMessage({
                          id: "additional.boradcast.years",
                        })}
                        name="additionalboradcastyears"
                        id="additionalboradcastyears"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="m-t-10">
                      <RadioButtonGroup
                        id="forquiz"
                        required
                      >
                        <Field
                          component={RadioButton}
                          name="forquiz"
                          id="forum"
                          label="Forum"
                          value="forum"
                        />
                        <Field
                          component={RadioButton}
                          name="forquiz"
                          id="quiz"
                          label="Quiz"
                          value="quiz"
                        />
                      </RadioButtonGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="required-creds">
                        <img src="/icons/equals.png" alt="equals" draggable="false" />
                        {/* <pre>{JSON.stringify(values,null, 2)}</pre> */}
                        <span>
                          {
                            values.numberofrooms ||  values.numberofdays || values.additionalboradcastyears || values.forquiz ? (
                              (values.numberofrooms ? values.numberofrooms * 2 : 0)
                              +
                              (values.numberofdays ? values.numberofdays * 2 : 0)
                              +
                              ((values.additionalboradcastyears ? values.additionalboradcastyears * (values.numberofdays + values.numberofrooms) : 0))
                              +
                              (values.forquiz === 'forum' ? 1 : 2)
                            ) : 0
                          }
                        </span> crédits nécéssaires*
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button onClick={handleSubmit} variant="primary" >{intl.formatMessage({ id: 'add.credits' })}</Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="disclaimer">
                        <p>
                          2 crédits /jour/salle pour l'enregistrement et 1 an de diffusion,<br />
                            1 crédit par jour par salle pour 1 an de diffusion supplémentaire,<br />
                            1 crédit pour le forum pour toute la durée de l'évènement,<br />
                            2 crédits pour le quizz pour toute la durée de l'évènement.
                           </p>
                      </div>
                    </Col>
                  </Row>
                </Form>
              )
            }}
          </Formik>
        </div>
      </div>
    </div>
  )
}

export default SimulatorPopup;